import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header d-flex justify-content-between align-items-start" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = {
  key: 2,
  class: "d-block fw-normal"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-x" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "col-4 d-flex" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_21 = {
  key: 1,
  class: "form-messages mt-2 px-1"
}
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = ["disabled", "min"]
const _hoisted_28 = { class: "col-4 d-flex" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_32 = {
  key: 1,
  class: "form-messages mt-2 px-1"
}
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["value", "selected"]
const _hoisted_38 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_40 = { class: "col-12" }
const _hoisted_41 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_42 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_43 = ["disabled", "placeholder"]
const _hoisted_44 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_47 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_48 = ["disabled", "placeholder"]
const _hoisted_49 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_50 = { class: "modal-footer" }
const _hoisted_51 = {
  key: 0,
  class: "text-center w-100"
}
const _hoisted_52 = {
  key: 1,
  class: "d-flex justify-content-between w-100"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_54 = { class: "position-relative" }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  key: 2,
  type: "submit",
  class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
}
const _hoisted_57 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _ctx.id,
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, [
              (_ctx.event_update)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cta.edit_event')), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cta.add_event')), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */)),
              (_ctx.patient_summary !== undefined)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.patient_summary.firstname) + " " + _toDisplayString(_ctx.patient_summary.lastname), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("button", {
              class: "bg-transparent border-0 close-btn lh-1 p-10 text-muted",
              type: "button",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restoreData()))
            }, [..._hoisted_8])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.time)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createCommentVNode(" START AT "),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('form.start_at.label')) + "* ", 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.event.started_at) = $event)),
                            type: "date",
                            required: "",
                            disabled: !_ctx.editable,
                            class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.started_at }]])
                          }, null, 10 /* CLASS, PROPS */, _hoisted_16), [
                            [_vModelText, _ctx.event.started_at]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.event.start_time) = $event)),
                            pattern: "[0-9]{2}:[0-9]{2}",
                            type: "time",
                            required: "",
                            class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.start_time }]]),
                            disabled: _ctx.event.all_day || !_ctx.editable
                          }, null, 10 /* CLASS, PROPS */, _hoisted_18), [
                            [_vModelText, _ctx.event.start_time]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createCommentVNode(" ERRORS "),
                          (_ctx.errors?.started_at ?? false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.started_at, (error) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: error,
                                    class: "small text-danger lh-1 m-0 mt-1"
                                  }, _toDisplayString(error), 1 /* TEXT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" ERRORS "),
                          (_ctx.errors?.start_time ?? false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.started_at, (error) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: error,
                                    class: "small text-danger lh-1 m-0 mt-1"
                                  }, _toDisplayString(error), 1 /* TEXT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ])
                  ]),
                  _createCommentVNode(" END AT "),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('form.end_at.label')) + "* ", 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.event.ended_at) = $event)),
                            type: "date",
                            required: "",
                            disabled: !_ctx.editable,
                            class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.ended_at }]]),
                            min: _ctx.event.started_at
                          }, null, 10 /* CLASS, PROPS */, _hoisted_27), [
                            [_vModelText, _ctx.event.ended_at]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.event.end_time) = $event)),
                            pattern: "[0-9]{2}:[0-9]{2}",
                            type: "time",
                            disabled: _ctx.event.all_day || !_ctx.editable,
                            class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.end_time }], "form-control shadow-none text-black"]),
                            required: ""
                          }, null, 10 /* CLASS, PROPS */, _hoisted_29), [
                            [_vModelText, _ctx.event.end_time]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createCommentVNode(" ERRORS "),
                          (_ctx.errors?.ended_at ?? false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.ended_at, (error) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: error,
                                    class: "small text-danger lh-1 m-0 mt-1"
                                  }, _toDisplayString(error), 1 /* TEXT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" ERRORS "),
                          (_ctx.errors?.end_time ?? false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.end_time, (error) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: error,
                                    class: "small text-danger lh-1 m-0 mt-1"
                                  }, _toDisplayString(error), 1 /* TEXT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ])
                  ]),
                  _createCommentVNode(" ALL DAY "),
                  _createCommentVNode(" <div class=\"col-12\">\n                                <div class=\"form-check form-switch form-group mb-15 mb-sm-20 mb-md-25\">\n                                    <input class=\"form-check-input shadow-none me-8\" type=\"checkbox\" role=\"switch\"\n                                        v-model=\"event.all_day\" @change=\"resetTimes\">\n                                    <label class=\"form-check-label fw-medium position-relative\">\n                                        {{ $t('feature.$events.all_day') }}\n                                    </label>\n                                </div>\n                            </div> "),
                  _createCommentVNode(" TYPE "),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('form.type.label')), 1 /* TEXT */),
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("select", {
                          class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.event_type_id }]]),
                          required: "",
                          disabled: !_ctx.editable,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.event.event_type_id) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event_types, (types) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: types.id,
                              value: types.id,
                              selected: _ctx.event.event_type_id === types.id
                            }, _toDisplayString(types.name), 9 /* TEXT, PROPS */, _hoisted_37))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 10 /* CLASS, PROPS */, _hoisted_36), [
                          [
                            _vModelSelect,
                            _ctx.event.event_type_id,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _createCommentVNode(" ERRORS "),
                        (_ctx.errors?.event_type_id ?? false)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.event_type_id, (error) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: error,
                                  class: "small text-danger lh-1 m-0 mt-1"
                                }, _toDisplayString(error), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]),
                  _hoisted_39,
                  _createCommentVNode(" LOCATION "),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('form.location.label')) + "* ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.event.location) = $event)),
                        required: "",
                        disabled: !_ctx.editable,
                        class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.location }], "form-control shadow-none text-black"]),
                        placeholder: _ctx.$t('form.location.placeholder')
                      }, null, 10 /* CLASS, PROPS */, _hoisted_43), [
                        [_vModelText, _ctx.event.location]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.location ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.location, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createCommentVNode(" DESCRIPTION "),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('form.description.label')), 1 /* TEXT */),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.event.description) = $event)),
                        class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.description }]]),
                        disabled: !_ctx.editable,
                        cols: "8",
                        placeholder: _ctx.$t('form.description.placeholder')
                      }, null, 10 /* CLASS, PROPS */, _hoisted_48), [
                        [_vModelText, _ctx.event.description]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.description ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.description, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_50, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createCommentVNode(" DELETE "),
                  (_ctx.event_update)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.deleteEvent && _ctx.deleteEvent(...args)))
                      }, [
                        _hoisted_53,
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('cta.delete_event')), 1 /* TEXT */)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_55)),
                  _createCommentVNode(" SAVE "),
                  (_ctx.event_update == undefined || _ctx.editable)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_56, _toDisplayString(_ctx.$t('cta.save_event')), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_57))
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}